import React from "react";

import ContentWrapperComponent from "./ContentUser"

const Component = ({ location }) => {
  let path = location.pathname;

  return (
    // <WithoutHeaderLayout location={location}>
    <div
      className={
        path.includes("/executive") || path.includes("/casual")
          ? "no-padding page-container"
          : "page-container"
      }
    >
      {/* <Header location={location} /> */}
      {/* START PAGE CONTENT WRAPPER */}
      <ContentWrapperComponent path={path} />
      {/* END PAGE CONTENT WRAPPER */}
    </div>
    // </WithoutHeaderLayout>
  );
};

export default Component;
